import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  listItemText: {
    listStyleType: 'none',
    marginTop: theme.spacing(-0.5),
    fontSize: '14px',
  },
  listItem: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-start',
    fontWeight: 400,
    width: '100%',
  },
}))
